import { Component } from '@angular/core';
import {OrderDetailActionsComponent, OrderDetailsService} from "@spartacus/order/components";
import {GonvarriOrder} from "../../core/models/gonvarri-order.model";
import {GonvarriOrderPdfAdapter} from "../../core/adapters/gonvarri-order-pdf.adapter";
import {downloadBytes} from "../../utils/download-bytes";

@Component({
    selector: 'cx-order-detail-actions',
    templateUrl: './gonvarri-order-detail-actions.component.html',
    styleUrl: './gonvarri-order-detail-actions.component.scss',
    standalone: false
})
export class GonvarriOrderDetailActionsComponent extends OrderDetailActionsComponent {

  constructor(
    private adapter: GonvarriOrderPdfAdapter,
    orderDetailsService: OrderDetailsService
  ) {
    super(orderDetailsService);
  }

  downloadCurrentOrder(order: GonvarriOrder): void {
    this.adapter.getSingleOrderPdf(
      order.code,
      "order",
      0
    ).subscribe((response: any) => downloadBytes(response, `PEDIDO ${order.code}`, "pdf"));
  }

}
